import React, { useMemo, useState } from 'react';
import {
    Button,
    Col,
    Form,
    FormControl,
    InputGroup,
    Modal,
    Row,
    Spinner,
    Table
} from 'react-bootstrap';
import { FaSearch, FaTimes } from 'react-icons/fa';
import EmailConfigViewmodel from './EmailConfig.viewmodel';
import { useAdminCompanies } from '../../../hooks';

export default function EmailConfig() {
    const {
        isLoading, emailConfigs, fetchEmailConfig,
        editingIndex, editForm, setEditForm,
        handleStartEdit, handleCancelEdit, handleSaveEdit,
        showCreateForm, createForm, setCreateForm,
        handleOpenCreate, handleCancelCreate, handleSaveCreate
    } = EmailConfigViewmodel();

    const { adminCompanies, isAllowedAllCompanies } = useAdminCompanies();

    const [searchSid, setSearchSid] = useState('');
    const [searchWfType, setSearchWfType] = useState('');
    const [searchWfCondition, setSearchWfCondition] = useState('');
    const [appliedSid, setAppliedSid] = useState('');
    const [appliedWfType, setAppliedWfType] = useState('');
    const [appliedWfCondition, setAppliedWfCondition] = useState('');

    const handleSearch = () => {
        setAppliedSid(searchSid);
        setAppliedWfType(searchWfType);
        setAppliedWfCondition(searchWfCondition);
        fetchEmailConfig();
    };

    const handleClear = () => {
        setSearchSid('');
        setSearchWfType('');
        setSearchWfCondition('');
        setAppliedSid('');
        setAppliedWfType('');
        setAppliedWfCondition('');
    };

    const filteredEmailConfigs = useMemo(
        () =>
            emailConfigs?.filter(emailConfig => {
                const matchAdmin =
                    isAllowedAllCompanies ||
                    adminCompanies?.some(
                        adminCompany => adminCompany.sid === emailConfig.sid
                    );
                const matchSid = !appliedSid ||
                    (emailConfig.sid ?? '').toLowerCase().includes(appliedSid.toLowerCase());
                const matchWfType = !appliedWfType ||
                    (emailConfig.wftype ?? '').toLowerCase().includes(appliedWfType.toLowerCase());
                const matchWfCondition = !appliedWfCondition ||
                    (emailConfig.wfcondition ?? '').toLowerCase().includes(appliedWfCondition.toLowerCase());
                return matchAdmin && matchSid && matchWfType && matchWfCondition;
            }),
        [isAllowedAllCompanies, adminCompanies, emailConfigs, appliedSid, appliedWfType, appliedWfCondition]
    );

    return (
        <div>
            <div className="master-data-content">
                <div
                    className="trapezoid-head"
                    style={{ width: '200px' }}
                >
                    <span>Email Config</span>
                </div>

                <div className="mat-box">
                    <Row>
                        <Col>
                            <div className='trapezoid trapezoid-purple' style={{ width: '200px', display: 'inline-block' }}>
                                <span>
                                    <i className="fa fa-search" aria-hidden="true"></i>
                                    Search menu
                                </span>
                            </div>
                            <div className="mat-box shadow p-3 mb-5 bg-white rounded">
                                <Row>
                                    <Col>
                                        <div className="mt-2">
                                            <Row>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3" controlId="searchSid">
                                                        <Form.Label>SID :</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            size="sm"
                                                            value={searchSid}
                                                            onChange={(e) => setSearchSid(e.target.value)}
                                                            onKeyPress={(e: any) => { if (e.key === 'Enter') handleSearch(); }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3" controlId="searchWfType">
                                                        <Form.Label>WF TYPE :</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            size="sm"
                                                            value={searchWfType}
                                                            onChange={(e) => setSearchWfType(e.target.value)}
                                                            onKeyPress={(e: any) => { if (e.key === 'Enter') handleSearch(); }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="mb-3" controlId="searchWfCondition">
                                                        <Form.Label>WF CONDITION :</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            size="sm"
                                                            value={searchWfCondition}
                                                            onChange={(e) => setSearchWfCondition(e.target.value)}
                                                            onKeyPress={(e: any) => { if (e.key === 'Enter') handleSearch(); }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <div style={{ marginTop: '1.75rem', textAlign: 'right' }}>
                                                        <Button variant="outline-info" size="sm" onClick={handleSearch}>
                                                            <FaSearch /> Search
                                                        </Button>
                                                        <Button variant="outline-secondary" size="sm" className="mx-2" onClick={handleClear}>
                                                            <FaTimes /> Clear
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="container">
                                <div className="mb-3 flex items-center justify-between">
                                    <div
                                        className="trapezoid trapezoid-purple"
                                        style={{
                                            display: 'inline-block',
                                            width: 'fit-content'
                                        }}
                                    >
                                        <span>
                                            <i
                                                className="fa fa-search"
                                                aria-hidden="true"
                                            ></i>
                                            Email Config
                                        </span>
                                    </div>
                                    <Button
                                        variant="success"
                                        size="sm"
                                        onClick={handleOpenCreate}
                                    >
                                        <i className="fa fa-plus mr-1" aria-hidden="true"></i>
                                        Add Config
                                    </Button>
                                </div>
                                {/*<div*/}
                                {/*    style={{*/}
                                {/*        display: 'inline-block',*/}
                                {/*        float: 'right'*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*    <Button*/}
                                {/*        className="mx-2"*/}
                                {/*        variant="outline-info"*/}
                                {/*        size="sm"*/}
                                {/*        onClick={() => {*/}
                                {/*        }}*/}
                                {/*    >*/}
                                {/*        <FaPlusCircle/>*/}
                                {/*        &nbsp;Save*/}
                                {/*    </Button>*/}
                                {/*</div>*/}
                                <div className="divide-y border-x">
                                    <div className="flex bg-neutral-200">
                                        <div className="flex-1 py-1.5 text-center font-semibold">
                                            Config
                                        </div>
                                        <div className="flex-[2] py-1.5 text-center font-semibold">
                                            Content
                                        </div>
                                    </div>
                                    {filteredEmailConfigs?.map((emailConfig, index) => (
                                        <div
                                            key={index}
                                            className="flex gap-4 p-4"
                                        >
                                            <div className="flex-1">
                                                <div className="flex w-full flex-col gap-1">
                                                    <InputGroup>
                                                        <Form.Group
                                                            className="w-full"
                                                            controlId="formBasicEmail"
                                                        >
                                                            <Form.Label>
                                                                SID :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="sid"
                                                                value={
                                                                    emailConfig.sid
                                                                }
                                                                readOnly
                                                            />

                                                            <Form.Label className="mt-3">
                                                                WF TYPE :
                                                            </Form.Label>
                                                            {editingIndex === index ? (
                                                                <FormControl
                                                                    className="w-full"
                                                                    placeholder="wftype"
                                                                    value={editForm.wftype}
                                                                    onChange={e => setEditForm({ ...editForm, wftype: e.target.value })}
                                                                />
                                                            ) : (
                                                                <FormControl
                                                                    className="w-full"
                                                                    placeholder="wftype"
                                                                    value={emailConfig.wftype}
                                                                    readOnly
                                                                />
                                                            )}

                                                            <Form.Label className="mt-3">
                                                                WF CONDITION :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="wfcondition"
                                                                value={
                                                                    emailConfig.wfcondition
                                                                }
                                                                readOnly
                                                            />

                                                            <Form.Label className="mt-3">
                                                                Email CC :
                                                            </Form.Label>
                                                            {editingIndex === index ? (
                                                                <FormControl
                                                                    className="w-full"
                                                                    placeholder="emailcc"
                                                                    value={editForm.emailcc}
                                                                    onChange={e => setEditForm({ ...editForm, emailcc: e.target.value })}
                                                                />
                                                            ) : (
                                                                <FormControl
                                                                    className="w-full"
                                                                    placeholder="emailcc"
                                                                    value={emailConfig.emailcc}
                                                                    readOnly
                                                                />
                                                            )}

                                                            <Form.Label className="mt-3">
                                                                Email BCC :
                                                            </Form.Label>
                                                            {editingIndex === index ? (
                                                                <FormControl
                                                                    className="w-full"
                                                                    placeholder="emailbcc"
                                                                    value={editForm.emailbcc}
                                                                    onChange={e => setEditForm({ ...editForm, emailbcc: e.target.value })}
                                                                />
                                                            ) : (
                                                                <FormControl
                                                                    className="w-full"
                                                                    placeholder="emailbcc"
                                                                    value={emailConfig.emailbcc}
                                                                    readOnly
                                                                />
                                                            )}

                                                            <div className="mt-3">
                                                                {editingIndex === index ? (
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Show JSON Report"
                                                                        checked={editForm.showjsonreport}
                                                                        onChange={e => setEditForm({ ...editForm, showjsonreport: e.target.checked })}
                                                                    />
                                                                ) : (
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="Show JSON Report"
                                                                        checked={emailConfig.showjsonreport === 'true'}
                                                                        disabled
                                                                    />
                                                                )}
                                                            </div>
                                                        </Form.Group>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                            <div className="flex-[2]">
                                                <div className="flex w-full flex-col">
                                                    <div className="mb-2 flex justify-end">
                                                        {editingIndex === index ? (
                                                            <div className="flex gap-2">
                                                                <Button variant="primary" size="sm" onClick={handleSaveEdit}>Save</Button>
                                                                <Button variant="danger" size="sm" onClick={handleCancelEdit}>Cancel</Button>
                                                            </div>
                                                        ) : (
                                                            <Button variant="warning" size="sm" onClick={() => handleStartEdit(index)}>Edit</Button>
                                                        )}
                                                    </div>
                                                    <Form.Label className="">
                                                        Subject :
                                                    </Form.Label>
                                                    {editingIndex === index ? (
                                                        <FormControl
                                                            as="textarea"
                                                            rows={3}
                                                            className="w-full font-mono text-sm"
                                                            value={editForm.contentsubject}
                                                            onChange={e => setEditForm({ ...editForm, contentsubject: e.target.value })}
                                                        />
                                                    ) : (
                                                        <div
                                                            className="form-control hover:none prose w-full max-w-none bg-[#e9ecef] px-4 text-sm"
                                                            dangerouslySetInnerHTML={{
                                                                __html: emailConfig.contentsubject
                                                            }}
                                                        />
                                                    )}
                                                    <Form.Label className="mt-3">
                                                        Body :
                                                    </Form.Label>
                                                    {editingIndex === index ? (
                                                        <FormControl
                                                            as="textarea"
                                                            rows={12}
                                                            className="w-full font-mono text-sm"
                                                            value={editForm.contentbody}
                                                            onChange={e => setEditForm({ ...editForm, contentbody: e.target.value })}
                                                        />
                                                    ) : (
                                                        <div
                                                            className="prose w-full max-w-none text-sm"
                                                            dangerouslySetInnerHTML={{
                                                                __html: emailConfig.contentbody
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <Modal show={showCreateForm} onHide={handleCancelCreate} size="lg">
                <Modal.Header closeButton translate={undefined}>
                    <Modal.Title>Add Email Config</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="create-sid">
                        <Form.Label>SID</Form.Label>
                        <FormControl
                            placeholder="sid"
                            value={createForm.sid}
                            onChange={e => setCreateForm({ ...createForm, sid: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="create-wftype">
                        <Form.Label>WF TYPE</Form.Label>
                        <FormControl
                            placeholder="wftype"
                            value={createForm.wftype}
                            onChange={e => setCreateForm({ ...createForm, wftype: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="create-wfcondition">
                        <Form.Label>WF CONDITION</Form.Label>
                        <FormControl
                            placeholder="wfcondition"
                            value={createForm.wfcondition}
                            onChange={e => setCreateForm({ ...createForm, wfcondition: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="create-emailcc">
                        <Form.Label>Email CC</Form.Label>
                        <FormControl
                            placeholder="emailcc"
                            value={createForm.emailcc}
                            onChange={e => setCreateForm({ ...createForm, emailcc: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="create-emailbcc">
                        <Form.Label>Email BCC</Form.Label>
                        <FormControl
                            placeholder="emailbcc"
                            value={createForm.emailbcc}
                            onChange={e => setCreateForm({ ...createForm, emailbcc: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="create-showjsonreport">
                        <Form.Check
                            type="checkbox"
                            label="Show JSON Report"
                            checked={createForm.showjsonreport}
                            onChange={e => setCreateForm({ ...createForm, showjsonreport: e.target.checked })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="create-subject">
                        <Form.Label>Subject</Form.Label>
                        <FormControl
                            as="textarea"
                            rows={3}
                            className="font-mono text-sm"
                            placeholder="subject (HTML)"
                            value={createForm.contentsubject}
                            onChange={e => setCreateForm({ ...createForm, contentsubject: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="create-body">
                        <Form.Label>Body</Form.Label>
                        <FormControl
                            as="textarea"
                            rows={8}
                            className="font-mono text-sm"
                            placeholder="body (HTML)"
                            value={createForm.contentbody}
                            onChange={e => setCreateForm({ ...createForm, contentbody: e.target.value })}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleCancelCreate}>Cancel</Button>
                    <Button variant="success" onClick={handleSaveCreate}>Create</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
